var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"wl-check",class:{'wl-check--ischecked' : _vm.checked},attrs:{"id":_vm.id},on:{"click":function($event){return _vm.select()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }